import * as Sentry from "@sentry/react";
import { Badge, Image } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { CustomButton } from "../../../components";
import { useLogin } from "../../../context/LoginContext";
import { useShoppingCart } from "../../../context/ShoppingCartContext";
import localStorageKey from "../../../enumerations/localStorageKey";
import { useGetUserInfo } from "../../../hooks/UserCenter/usercenter.hooks";
import { pushGtag } from "../../../plugins/gtagFunction";
import { scrollToElementById } from "../../../plugins/scrollFunction";
import DrawerMenu from "./components/DrawerMenu";
import LangSelector from "./components/LangSelector";
import UserIconMenu from "./components/UserIconMenu";
import Cart from "./images/layout2/Cart";
import userIcon from "./images/layout2/userIcon.png";
import styles from "./style.2esim.module.scss";

const Header = ({ hideMenu }: { hideMenu: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { cartCount } = useShoppingCart();
  const { setIsLogin } = useLogin();
  const localToken = window.localStorage.getItem(localStorageKey.TOKEN);
  const userName = window.localStorage.getItem(localStorageKey.USER_NAME);
  const {
    data: userInfo,
    isSuccess,
    isError,
  } = useGetUserInfo({ enabled: !!localToken });

  const leftMenu = [
    {
      name: t("normal.product"),
      path: "",
      itemOnClick: () => {
        // console.log("window.location.pathname", window.location.pathname);
        if (window.location.pathname === "/") {
          scrollToElementById("homeProductArea");
          return;
        }
        navigate("/", { state: { area: "homeProductArea" } });
      },
    },
    {
      name: t("normal.brand.introduction"),
      path: "/brand",
      hide: process.env.REACT_APP_HIDE_BRAND_STORY,
    },
    {
      name: t("header.esim.guide"),
      path: "/installguide",
    },
    {
      name: t("normal.common.issue"),
      path: "/commonissue",
    },
  ];
  useEffect(() => {
    if (isSuccess && userInfo) {
      // console.log(`userInfo: ${JSON.stringify(userInfo)}.`);

      setIsLogin(true);
      window.localStorage.setItem(localStorageKey.USER_ACCOUNT, userInfo.email);
      window.localStorage.setItem(localStorageKey.USER_NAME, userInfo.name);
      Sentry.setUser({
        id: userInfo.account_id,
        username: userInfo.email,
        email: userInfo.email,
      });

      return;
    }
    if (isError) {
      setIsLogin(false);
      return;
    }
  }, [isSuccess, isError, userInfo]);

  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <DrawerMenu />
          <img
            src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/header_logo.png`}
            className={styles.headerLogo}
            // preview={false}
            alt="2esim-header"
            onClick={() => (window.location.href = "/")}
          />
        </div>
        <div className={styles.rightContainer}>
          {hideMenu ? (
            ""
          ) : (
            <div className={styles.menu}>
              {leftMenu
                .filter((_menu) => !_menu.hide)
                .map((menuItem) => (
                  <Link
                    to={menuItem.path}
                    className={styles.link}
                    key={menuItem.name}
                    onClick={(e) => {
                      if (menuItem.itemOnClick) {
                        e.preventDefault();
                        menuItem.itemOnClick();
                      }
                    }}
                  >
                    {t(menuItem.name)}
                  </Link>
                ))}
            </div>
          )}
          {/* <div className={styles.show}>
            <CustomGiftPoint number={giftPoint} />
          </div> */}
          <LangSelector />
          <Link
            to={"/cart"}
            className={`${styles.link} ${styles.cart}`}
            style={hideMenu ? { display: "none" } : {}}
            onClick={() => {
              pushGtag({
                event: "header_cart_click",
              });
            }}
          >
            {process.env.REACT_APP_PROD_NAME_DEV === "2esim" ? (
              <Cart color="var(--primary600)" size={24} />
            ) : (
              <>{t("normal.cart")}</>
            )}
            <Badge count={cartCount} />
          </Link>
          {/* <div className={styles.hide}>
            <CustomGiftPoint number={giftPoint} />
          </div> */}
          {hideMenu ? (
            ""
          ) : userInfo ? (
            <UserIconMenu>
              <div style={{ gap: 5, display: "flex", alignItems: "center" }}>
                <Image
                  src={userIcon}
                  className={styles.userLogo}
                  preview={false}
                />
                <div className={styles.userName}>
                  {userName ? userName : "User"}
                </div>
              </div>
            </UserIconMenu>
          ) : (
            <div className={styles.hideLogin}>
              <CustomButton
                type="primary"
                danger
                onClick={() => {
                  navigate("/signin");
                  pushGtag({
                    event: "header_signin_click",
                  });
                }}
              >
                {t("header.signin.signup")}
              </CustomButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
